// extracted by mini-css-extract-plugin
export var icon = "CruiseDrawerItineraryHilights-module--icon--12262";
export var list = "CruiseDrawerItineraryHilights-module--list--1a28c";